<template>
<!--物联网卡号对应的二维码微信支付界面-->
<el-dialog :title="isChargeSuccess==0?'物联卡批量充值二维码':'物联卡批量充值结果'" :visible.sync="cardQrcodeVisible" :close-on-click-modal="false" width="30%" :before-close="closeDialog">
    <!--默认充值页面-->
    <template v-if="isChargeSuccess==0">
        <div style="text-align:center;font-weight:bold;">本次共充值：<span style="color:red;font-size:17px">{{this.total}}</span> 张卡，实际缴费金额：<span style="color:red;font-size:22px">￥{{this.rechargePrice}}</span> 元 </div>
        <qrcode :value="url" class="qrcode"></qrcode>
        <div style="text-align:center;"><span class="iconfont icon-saoma" style="font-size:24px;vertical-align:middle;"></span> &nbsp;&nbsp;请打开 <span class="iconfont icon-weixindenglu" style="font-size:16px;vertical-align:middle;color:#00c800;"></span> <span style="color:#0099cb">微信APP扫码</span> 支付物联网卡费用</div>
    </template>
    <!--充值成功页面-->
    <template v-if="isChargeSuccess==1">
        <div style="text-align:center;"><span class="iconfont icon-weixinzhifu" style="font-size:100px;vertical-align:middle;color:#00c800;"></span></div>
        <div style="text-align:center;color:#00c800;margin-top:10px;font-size:22px;">支付成功</div>
        <div style="text-align:center;margin-top:30px;font-size:35px;">{{rechargePrice}}元</div>
        <div style="text-align:center;margin-top:10px;font-size:14px;color:gray;">{{countDownTime}}秒后自动关闭</div>
        <div style="text-align:center;margin-top:30px;">
            <el-button type="success" plain @click="closeDialog">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;完 成&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        </div>
    </template>
    <!--充值失败页面-->
    <template v-if="isChargeSuccess==-1">
        <div style="text-align:center;"><span class="iconfont icon-zhifushibai" style="font-size:100px;vertical-align:middle;color:#E6A23C;"></span></div>
        <div style="text-align:center;margin-top:10px;font-size:22px;">充值失败</div>
        <div style="text-align:center;margin-top:10px;font-size:14px;color:gray;">如有疑问请联系客服</div>
        <el-divider></el-divider>
        <div style="margin-left:60px;margin-right:60px;margin-top:30px;font-size:16px;">
            <el-row style="line-height:30px;">
                <el-col :span="10">
                    <div style="text-align:left;">订单编号：</div>
                </el-col>
                <el-col :span="14">
                    <div style="text-align:right;font-size:14px;">{{orderId}}</div>
                </el-col>
            </el-row>
            <el-row style="line-height:30px;">
                <el-col :span="10">
                    <div style="text-align:left;">充值失败：</div>
                </el-col>
                <el-col :span="14">
                    <div style="text-align:right;">{{rechargePrice}}元</div>
                </el-col>
            </el-row>
        </div>
        <div style="text-align:center;margin-top:30px;">
            <el-button type="info" plain @click="failToTry">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重 试&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        </div>
    </template>
</el-dialog>
</template>

<script>
import Qrcode from '@chenfengyuan/vue-qrcode';
import {
    getBatchRechargePaySuccess
} from '../api/api';

export default {
    components: {
        qrcode: Qrcode
    },
    data() {
        return {
            isChargeSuccess: 0, //0：充值页面，1：充值成功，-1：充值失败
            timer: null,
            num: 0,
            total: 0,
            cardQrcodeVisible: false,
            rechargePrice: 0,
            url_prefix: "http://www.yunkawulian.com/mobile/bathRechargeReward.html?",
            url: "",
            countDownTime: 20,
            orderId: ""
        }
    },
    methods: {
        showCardQrcode(orderId, rechargePrice, total) {
            this.orderId = orderId;
            // this.orderId='B2005240206469711146400';
            this.total = total;
            this.rechargePrice = rechargePrice;
            var param = "orderId=" + orderId + "&toptalPrice=" + rechargePrice
            this.url = this.url_prefix + param;
            this.cardQrcodeVisible = true;
            //开启定时任务检测服务端orderId是否存在，如果不存在，则视为支付成功。切换到支付成功页面
            this.isChargeSuccess = 0;
            // 实现轮询
            this.timer = window.setInterval(() => {
                setTimeout(this.getUserOrderPayIsSuccess(), 0);
            }, 3000);
        },
        // 获取用户订单支付是否成功
        getUserOrderPayIsSuccess: function () {
            console.log("请求" + this.num++ + "次");
            let param = {
                orderId: this.orderId
            };
            getBatchRechargePaySuccess(param).then((res) => {
                let {
                    msg,
                    code
                } = res;
                if (code == 0) {
                    if (res.data.paySuccess == 1) {

                        this.isChargeSuccess = 1;
                        clearInterval(this.timer);

                        let me = this;
                        let interval = window.setInterval(function () {
                            console.log("倒计时" + me.countDownTime + "秒");
                            --me.countDownTime;
                            if (me.countDownTime < 0) {
                                me.countDownTime = 20;
                                window.clearInterval(interval);
                                me.closeDialog();
                            }
                        }, 1000);
                        this.num = 0;
                    }
                }
                if (this.num > 10) {
                    clearInterval(this.timer);
                    //TODO:提示失败或者二维码失效
                    this.isChargeSuccess = -1;
                    this.num = 0;

                }
            });
        },
        closeDialog() {
            clearInterval(this.timer);
            console.log("关闭窗口啦...");
            this.cardQrcodeVisible = false;
            this.num = 0;
            this.countDownTime = 20;
        },
        failToTry() {
            this.isChargeSuccess = 0;
            //开启定时任务检测服务端orderId是否存在，如果不存在，则视为支付成功。切换到支付成功页面
            // 实现轮询
            this.timer = window.setInterval(() => {
                setTimeout(this.getUserOrderPayIsSuccess(), 0);
            }, 3000);
        }

    },
    destroyed() {
        clearInterval(this.timer);
    }
}
</script>

<style>
.qrcode {
    width: 100% !important;
    height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// bath_qrcode.vue?e35a5626